import {useMutation, useQueryClient} from '@tanstack/react-query'

import {equipmentCheckKeys} from 'src/equipment-checks/query-keys'

import {setThirdPartyUnitNumber} from './api'
import {mapOperationalJobDetail} from './job-api-adapter'
import {jobKeys} from './query-keys'

export function useSetThirdPartyUnitNumber(jobId: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async ({
            rentalAssetId,
            unitNumber,
        }: {
            rentalAssetId: string
            unitNumber: string | null
        }) =>
            mapOperationalJobDetail(
                await setThirdPartyUnitNumber(jobId, rentalAssetId, unitNumber),
            ),
        onSuccess: () => {
            void queryClient.invalidateQueries({queryKey: jobKeys.detail(jobId)})
            void queryClient.invalidateQueries({queryKey: equipmentCheckKeys.all()})
        },
    })
}
